import axios from 'axios'
import { EmissionMapping } from '../../models/emissionMapping'
import { API_ROUTES } from '../routes'

export const getEmissionMapping = async () => {
  return await axios.get<EmissionMapping[]>(API_ROUTES.EMISSION_MAPPING)
}
